import {MarkedTypeEnum} from '@doltech/utils/lib/constants';
import {Instance, types} from 'mobx-state-tree';

export const BlankItem = types
  .model('BlankItem', {
    no: types.optional(types.number, 0),
    key: types.number,
    id: types.identifier,
    userAnswer: types.maybeNull(types.string),
    correctAnswer: types.maybeNull(types.string),
    markedType: types.maybeNull(
      types.enumeration<MarkedTypeEnum>('MarkedTypeEnum', Object.values(MarkedTypeEnum))
    ),
  })
  .actions((self) => ({
    setKey(key: number) {
      self.key = key;
    },
    setUserAnswer(value: string) {
      self.userAnswer = value;
    },
    clearUserAnswer() {
      self.userAnswer = '';
    },
  }));

export interface BlankItemInstance extends Instance<typeof BlankItem> {}
